import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { LetterDocumentService } from '../../Model/LetterDocument/letter-document.service';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../../Util/Session/session.service';
import { ConfirmationComponent } from '../Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-ifream-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ifream-dialog.component.html',
  styleUrl: './ifream-dialog.component.scss'
})
export class IfreamDialogComponent {
  isDisabled = false;
  //@Input() URL: string = '';
  @Input() email: string = '';
  @Input() city: string = '';
  @Input() data: any = {};
  safeUrl: any;
  totalPages = 0;
  showIfream = false;
  user = [] as any;
  GroupID = null;

  constructor(
    private activeModal: NgbActiveModal,
    protected sanitizer: DomSanitizer,
    private toast: ToastService,
    private letterDocument: LetterDocumentService,
    private session: SessionService,
    private http: HttpClient,
    private modalService: NgbModal,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    //this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.URL);
  }

  Validate(form: any, Name: any) {
    if (form.valid) {
      if (this.email != null && this.email != '' && this.city != null && this.city != '') {
        this.ganrateLetter();
      } else {
        this.toast.show({ message: 'Please fill mandatory fields', type: toastTypeEnum.danger });
      }
    } else {
      this.toast.show({ message: 'Please fill mandatory fields', type: toastTypeEnum.danger });
      form.submitted = true;
    }
  }

  close(result: boolean) {
    if (!result) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to close esign?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.activeModal.close({ result: result, GroupID: this.GroupID });
        }
      });
    } else { this.activeModal.close({ result: result, GroupID: this.GroupID }); }

  }

  ganrateLetter() {
    this.isDisabled = true;
    this.http.get(this.data.LetterGenerationFileName, { responseType: 'blob' }).subscribe((blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.letterDocument.ZoopEsignProcess({
          documentName: this.data.LetterName,
          base64Document: reader.result?.toString().replace("data:application/pdf;base64,", ""),
          documentInfo: 'Letter',
          //signers: [{ signer_name: this.user.UserName, signer_email: 'matin.mansuri@maxus.co.in', signer_city: 'surat', signer_purpose: 'Letter Acknowlegment', sign_coordinates: [{ page_num: this.TableDatas[index].AddESignInOn == 'firstpageonly'?1:this.TableDatas[index].AddESignInOn == 'lastpageonly'?10:0, x_coord: this.TableDatas[index].Xcoordinate, y_coord: this.TableDatas[index].Ycoordinate }] }],
          signers: [{ signer_name: this.user.UserName, signer_email: this.email, signer_city: this.city, signer_purpose: 'Acknowledged', sign_coordinates: [{ page_num: this.data.AddESignInOn == 'firstpageonly' ? 1 : this.data.AddESignInOn == 'lastpageonly' ? -1 : 0, x_coord: this.data.Xcoordinate, y_coord: this.data.Ycoordinate }] }],
        }).subscribe({
          next: (response) => {
            if (response.signUrl != null && response.signUrl != '' && response.groupId != null && response.groupId != '') {
              this.showIfream = true;
              this.GroupID = response.groupId;
              this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.signUrl);
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      };
      reader.readAsDataURL(blob); // Read the Blob as a data URL
    }, error => {
      console.error('Error fetching the image:', error);
    });
  }
}
